/* Http Client */
import request from '@/utils/http/request'


export const _STATUS = {
    0: "取消轉讓",
    1: "轉讓中",
    2: "轉讓成功",
    3: "轉讓失敗",
}


export const _STATUS_COLOR = {
    0: "",
    1: "orange",
    2: "#87d068",
    3: "#f50",
}


//List
export async function fetchAll({ status, phone, sDate, eDate, transactionType, pageSize, pageNumber }) {
    return await request.get('/members/points/transfer', {
        params: {
            status, phone, sDate, eDate, transactionType, pageSize, pageNumber
        }

    });
}


